module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Ge-Ha-Ia.21d68971.png";